import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import CTASection from '@/pages/home/components/CTASection';
import { comments } from '@/mocks/articles';
import { siteInfo } from '@/mocks/site';
import {
  OrganizationSchema,
  WebSiteSchema,
  WebPageSchema,
  BreadcrumbListSchema,
  FAQPageSchema,
} from '@/components/feature/SchemaOrg';

const aboutFaqs = [
  {
    question: '吃瓜群是什么平台？',
    answer: `吃瓜群成立于${siteInfo.foundedYear}年，是一个专注于娱乐八卦、网红爆料、明星黑料等内容追踪与分享的平台。我们致力于为广大"吃瓜群众"提供最新、最全、最真实的爆料资讯，打造一个自由、开放的吃瓜交流社区。目前已累计追踪爆料事件超过${siteInfo.totalExposures}件，日活跃用户数十万。`,
  },
  {
    question: '吃瓜群的爆料内容可靠吗？',
    answer: '吃瓜群坚持真实爆料、拒绝谣言的原则。每一条爆料都会经过多方信息交叉核实，编辑团队由资深娱乐记者和自媒体人组成。但我们仍提醒广大吃瓜群众理性吃瓜，对于尚未充分证实的消息保持审慎态度，不信谣不传谣。',
  },
  {
    question: '如何在吃瓜群投稿爆料？',
    answer: `如果你有第一手内幕信息想爆料，可以通过爆料邮箱 ${siteInfo.email} 发送邮件，或在QQ吃瓜群（群号：${siteInfo.qqGroupNumber}）内联系管理员。我们将保护爆料人的隐私信息，并对爆料内容进行核实后发布。`,
  },
  {
    question: '吃瓜群有移动端App吗？',
    answer: '目前吃瓜群主要通过网页端和QQ群运营，暂时没有独立App。你可以将吃瓜群官网添加到手机浏览器书签，方便随时访问最新爆料内容。未来我们也会考虑开发移动端应用。',
  },
];

export default function AboutPage() {
  const canonicalUrl = typeof window !== 'undefined' ? 'http://sxthpxzx.cn' : '';
  const aboutUrl = `${canonicalUrl}/about`;

  return (
    <>
      <OrganizationSchema />
      <WebSiteSchema />
      <WebPageSchema
        title={`关于我们 - ${siteInfo.name}`}
        description={`${siteInfo.name}成立于${siteInfo.foundedYear}年，是国内领先的吃瓜内容平台。了解我们的品牌故事、平台特色、口碑信誉与联系方式。`}
        url={aboutUrl}
      />
      <BreadcrumbListSchema
        items={[
          { name: '首页', url: canonicalUrl },
          { name: '关于我们', url: aboutUrl },
        ]}
      />
      <Navbar />
      <main>
        {/* Breadcrumb */}
        <div className="w-full bg-background-50 pt-20 pb-4">
          <div className="w-full px-4 md:px-6">
            <div className="mx-auto max-w-7xl">
              <nav aria-label="面包屑导航" className="flex items-center gap-2 text-xs text-foreground-500">
                <Link to="/" className="hover:text-primary-500 transition-colors cursor-pointer">首页</Link>
                <i className="ri-arrow-right-s-line"></i>
                <span className="text-foreground-700 font-medium">关于我们</span>
              </nav>
            </div>
          </div>
        </div>

        {/* Brand Introduction */}
        <section className="w-full py-12 md:py-20 bg-background-50" id="brand">
          <div className="w-full px-4 md:px-6">
            <div className="mx-auto max-w-7xl">
              <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
                <div className="w-full lg:w-5/12">
                  <span className="inline-block px-3 py-1 bg-primary-100 text-primary-700 text-xs font-medium rounded-full mb-4">
                    品牌介绍
                  </span>
                  <h1 className="text-3xl md:text-5xl font-heading font-bold text-foreground-950 leading-tight">
                    吃瓜群
                    <br />
                    <span className="text-accent-500">吃瓜群众聚集地</span>
                    <span role="img" aria-label="西瓜"> 🍉</span>
                  </h1>
                  <p className="mt-6 text-base md:text-lg text-foreground-700 leading-relaxed">
                    吃瓜群成立于{siteInfo.foundedYear}年，是一个专注于娱乐八卦、网红爆料、明星黑料等内容追踪与分享的平台。
                    我们致力于为广大"吃瓜群众"提供最新、最全、最真实的爆料资讯，打造一个自由、开放的吃瓜交流社区。
                  </p>
                  <p className="mt-4 text-base text-foreground-700 leading-relaxed">
                    在这个信息爆炸的时代，吃瓜群坚持真实爆料、拒绝谣言的原则，每一条爆料都经过多方核实。我们的编辑团队由资深娱乐记者和自媒体人组成，
                    拥有丰富的行业资源和人脉网络，能够第一时间获取最劲爆的独家消息。
                  </p>
                  <p className="mt-4 text-base text-foreground-700 leading-relaxed">
                    截至目前，吃瓜群已累计追踪爆料事件超过{siteInfo.totalExposures}件，日活跃吃瓜用户数十万，
                    已成为国内最具影响力的吃瓜内容平台之一。
                  </p>
                  <Link
                    to="/"
                    className="inline-flex items-center gap-2 mt-6 text-primary-500 hover:text-primary-600 font-medium cursor-pointer"
                  >
                    浏览最新爆料 <i className="ri-arrow-right-line"></i>
                  </Link>
                </div>
                <div className="w-full lg:w-7/12">
                  <div className="relative">
                    <div className="grid grid-cols-2 gap-4">
                      <div className="rounded-2xl overflow-hidden aspect-[3/4] col-start-1">
                        <img
                          src="https://readdy.ai/api/search-image?query=Modern%20Chinese%20newsroom%20with%20multiple%20monitors%20displaying%20social%20media%20feeds%2C%20warm%20ambient%20lighting%2C%20editorial%20workspace%2C%20clean%20modern%20interior%2C%20professional%20atmosphere%2C%20abstract%20composition%2C%20warm%20orange%20accents&width=600&height=800&seq=about-img-01&orientation=portrait"
                          alt="吃瓜群编辑团队"
                          className="w-full h-full object-cover object-top"
                        />
                      </div>
                      <div className="rounded-2xl overflow-hidden aspect-[4/5] col-start-2 mt-8">
                        <img
                          src="https://readdy.ai/api/search-image?query=Collaborative%20team%20discussing%20latest%20news%20around%20a%20modern%20table%2C%20warm%20studio%20lighting%2C%20editorial%20office%20environment%2C%20creative%20atmosphere%2C%20clean%20modern%20interior%2C%20warm%20coral%20and%20amber%20tones&width=600&height=750&seq=about-img-02&orientation=portrait"
                          alt="吃瓜群团队协作"
                          className="w-full h-full object-cover object-top"
                        />
                      </div>
                    </div>
                    <div className="absolute top-4 right-4 flex gap-6">
                      <div className="text-center">
                        <p className="text-3xl md:text-4xl font-heading font-bold text-primary-500">{siteInfo.foundedYear}</p>
                        <p className="text-xs text-foreground-500 mt-1">成立年份</p>
                      </div>
                      <div className="text-center">
                        <p className="text-3xl md:text-4xl font-heading font-bold text-accent-500">{siteInfo.totalExposures}</p>
                        <p className="text-xs text-foreground-500 mt-1">追踪爆料</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Platform Data */}
        <section className="w-full py-12 md:py-20 bg-background-100">
          <div className="w-full px-4 md:px-6">
            <div className="mx-auto max-w-7xl">
              <div className="text-center mb-10 md:mb-14">
                <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950">
                  平台数据
                </h2>
                <p className="mt-3 text-sm md:text-base text-foreground-600">
                  用数字说话，吃瓜群的成长轨迹
                </p>
              </div>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
                <div className="bg-background-50 rounded-2xl p-6 md:p-8 text-center">
                  <p className="text-4xl md:text-5xl font-heading font-bold text-primary-500">12,800+</p>
                  <p className="mt-2 text-sm text-foreground-600">累计追踪爆料</p>
                </div>
                <div className="bg-background-50 rounded-2xl p-6 md:p-8 text-center">
                  <p className="text-4xl md:text-5xl font-heading font-bold text-accent-500">50万+</p>
                  <p className="mt-2 text-sm text-foreground-600">日活跃用户</p>
                </div>
                <div className="bg-background-50 rounded-2xl p-6 md:p-8 text-center">
                  <p className="text-4xl md:text-5xl font-heading font-bold text-secondary-500">6</p>
                  <p className="mt-2 text-sm text-foreground-600">大内容分类</p>
                </div>
                <div className="bg-background-50 rounded-2xl p-6 md:p-8 text-center">
                  <p className="text-4xl md:text-5xl font-heading font-bold text-primary-500">3</p>
                  <p className="mt-2 text-sm text-foreground-600">年持续运营</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Features */}
        <section className="w-full py-12 md:py-20 bg-background-50">
          <div className="w-full px-4 md:px-6">
            <div className="mx-auto max-w-7xl">
              <div className="text-center mb-10 md:mb-14">
                <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950">
                  我们的特色
                </h2>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
                <div className="bg-background-100 rounded-2xl p-6 md:p-7">
                  <div className="w-12 h-12 rounded-xl bg-primary-100 text-primary-600 flex items-center justify-center mb-4">
                    <i className="ri-timer-flash-line text-xl"></i>
                  </div>
                  <h3 className="text-lg font-heading font-bold text-foreground-950 mb-2">实时追踪</h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    7×24小时全天候追踪娱乐圈与网红圈动态，第一时间发布独家爆料，绝不让吃瓜群众错过任何大瓜。
                  </p>
                </div>
                <div className="bg-background-100 rounded-2xl p-6 md:p-7">
                  <div className="w-12 h-12 rounded-xl bg-accent-100 text-accent-600 flex items-center justify-center mb-4">
                    <i className="ri-user-voice-line text-xl"></i>
                  </div>
                  <h3 className="text-lg font-heading font-bold text-foreground-950 mb-2">网友爆料</h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    开放网友在线爆料投稿渠道，鼓励知情人士分享第一手内幕，汇聚民间力量深挖更多猛料。
                  </p>
                </div>
                <div className="bg-background-100 rounded-2xl p-6 md:p-7">
                  <div className="w-12 h-12 rounded-xl bg-secondary-100 text-secondary-600 flex items-center justify-center mb-4">
                    <i className="ri-file-list-3-line text-xl"></i>
                  </div>
                  <h3 className="text-lg font-heading font-bold text-foreground-950 mb-2">黑料大全</h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    系统整理每一条爆料的来龙去脉，建立完整的黑料档案库，方便吃瓜群众回顾和追踪事件进展。
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Reputation */}
        <section className="w-full py-12 md:py-20 bg-background-100" id="reputation">
          <div className="w-full px-4 md:px-6">
            <div className="mx-auto max-w-7xl">
              <div className="text-center mb-10 md:mb-14">
                <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950">
                  口碑与信誉
                </h2>
                <p className="mt-3 text-sm md:text-base text-foreground-600">
                  来自吃瓜群众的真实评价
                </p>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
                {comments.slice(0, 3).map((comment) => (
                  <div key={comment.id} className="bg-background-50 rounded-2xl p-5 md:p-6">
                    <div className="flex items-center gap-1 mb-3">
                      {Array.from({ length: 5 }).map((_, i) => (
                        <i
                          key={i}
                          className={`ri-star-fill text-sm ${
                            i < comment.stars ? 'text-secondary-500' : 'text-background-300'
                          }`}
                        ></i>
                      ))}
                    </div>
                    <p className="text-sm text-foreground-700 leading-relaxed line-clamp-4 mb-4">
                      &ldquo;{comment.content}&rdquo;
                    </p>
                    <div className="flex items-center gap-3 pt-4 border-t border-background-200">
                      <img
                        src={comment.avatar}
                        alt={comment.username}
                        className="w-9 h-9 rounded-full object-cover"
                      />
                      <div>
                        <p className="text-sm font-semibold text-foreground-900">{comment.username}</p>
                        <p className="text-xs text-foreground-500">{comment.date}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Business Cooperation & Contact */}
        <section className="w-full py-12 md:py-20 bg-background-50" id="contact">
          <div className="w-full px-4 md:px-6">
            <div className="mx-auto max-w-7xl">
              <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">
                {/* Business Cooperation */}
                <div className="w-full lg:w-1/2">
                  <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-6">
                    商务合作
                  </h2>
                  <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
                    吃瓜群作为国内领先的吃瓜内容平台，拥有庞大的活跃用户群体和强大的内容传播能力。
                    我们欢迎各类品牌合作，包括但不限于：
                  </p>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-6">
                    <div className="flex items-start gap-3 p-4 bg-background-100 rounded-xl">
                      <div className="w-10 h-10 rounded-lg bg-primary-100 text-primary-600 flex items-center justify-center flex-shrink-0">
                        <i className="ri-advertisement-line text-lg"></i>
                      </div>
                      <div>
                        <h4 className="text-sm font-semibold text-foreground-900">广告投放</h4>
                        <p className="text-xs text-foreground-500 mt-1">横幅广告、软文推广、品牌冠名等</p>
                      </div>
                    </div>
                    <div className="flex items-start gap-3 p-4 bg-background-100 rounded-xl">
                      <div className="w-10 h-10 rounded-lg bg-accent-100 text-accent-600 flex items-center justify-center flex-shrink-0">
                        <i className="ri-shake-hands-line text-lg"></i>
                      </div>
                      <div>
                        <h4 className="text-sm font-semibold text-foreground-900">内容合作</h4>
                        <p className="text-xs text-foreground-500 mt-1">联合选题、独家爆料、专题策划</p>
                      </div>
                    </div>
                    <div className="flex items-start gap-3 p-4 bg-background-100 rounded-xl">
                      <div className="w-10 h-10 rounded-lg bg-secondary-100 text-secondary-600 flex items-center justify-center flex-shrink-0">
                        <i className="ri-links-line text-lg"></i>
                      </div>
                      <div>
                        <h4 className="text-sm font-semibold text-foreground-900">流量互换</h4>
                        <p className="text-xs text-foreground-500 mt-1">友情链接、互推引流、资源置换</p>
                      </div>
                    </div>
                    <div className="flex items-start gap-3 p-4 bg-background-100 rounded-xl">
                      <div className="w-10 h-10 rounded-lg bg-primary-100 text-primary-600 flex items-center justify-center flex-shrink-0">
                        <i className="ri-megaphone-line text-lg"></i>
                      </div>
                      <div>
                        <h4 className="text-sm font-semibold text-foreground-900">品牌推广</h4>
                        <p className="text-xs text-foreground-500 mt-1">活动策划、品牌植入、KOL联动</p>
                      </div>
                    </div>
                  </div>
                  <p className="text-sm text-foreground-500">
                    商务合作请发送邮件至：
                    <a href={`mailto:${siteInfo.email}`} className="text-primary-500 hover:text-primary-600 font-medium ml-1 cursor-pointer">
                      {siteInfo.email}
                    </a>
                    ，我们将在1-3个工作日内回复。
                  </p>
                </div>

                {/* Contact Methods */}
                <div className="w-full lg:w-1/2">
                  <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-6">
                    联系方式
                  </h2>
                  <div className="space-y-4">
                    <div className="bg-background-100 rounded-2xl p-5 md:p-6 flex items-start gap-4">
                      <div className="w-12 h-12 rounded-xl bg-primary-100 text-primary-600 flex items-center justify-center flex-shrink-0">
                        <i className="ri-qq-line text-xl"></i>
                      </div>
                      <div>
                        <h3 className="text-base font-heading font-bold text-foreground-950 mb-1">QQ吃瓜群</h3>
                        <p className="text-sm text-foreground-600 mb-2">群号：{siteInfo.qqGroupNumber}，加入群聊实时吃瓜</p>
                        <a
                          href={`http://sxthpxzx.cn/q/${siteInfo.qqGroupNumber}`}
                          target="_blank"
                          rel="nofollow noopener noreferrer"
                          className="text-sm text-primary-500 hover:text-primary-600 font-medium cursor-pointer"
                        >
                          立即加入 <i className="ri-arrow-right-up-line ml-0.5"></i>
                        </a>
                      </div>
                    </div>
                    <div className="bg-background-100 rounded-2xl p-5 md:p-6 flex items-start gap-4">
                      <div className="w-12 h-12 rounded-xl bg-accent-100 text-accent-600 flex items-center justify-center flex-shrink-0">
                        <i className="ri-mail-line text-xl"></i>
                      </div>
                      <div>
                        <h3 className="text-base font-heading font-bold text-foreground-950 mb-1">爆料邮箱</h3>
                        <p className="text-sm text-foreground-600 mb-2">有料就发过来，我们保护你的隐私</p>
                        <a
                          href={`mailto:${siteInfo.email}`}
                          className="text-sm text-accent-500 hover:text-accent-600 font-medium cursor-pointer"
                        >
                          {siteInfo.email}
                        </a>
                      </div>
                    </div>
                    <div className="bg-background-100 rounded-2xl p-5 md:p-6 flex items-start gap-4">
                      <div className="w-12 h-12 rounded-xl bg-secondary-100 text-secondary-600 flex items-center justify-center flex-shrink-0">
                        <i className="ri-wechat-line text-xl"></i>
                      </div>
                      <div>
                        <h3 className="text-base font-heading font-bold text-foreground-950 mb-1">微信公众号</h3>
                        <p className="text-sm text-foreground-600 mb-2">搜索"吃瓜群"关注，每日推送热门大瓜</p>
                        <span className="text-sm text-secondary-500 font-medium">微信搜索：吃瓜群</span>
                      </div>
                    </div>
                    <div className="bg-background-100 rounded-2xl p-5 md:p-6 flex items-start gap-4">
                      <div className="w-12 h-12 rounded-xl bg-primary-100 text-primary-600 flex items-center justify-center flex-shrink-0">
                        <i className="ri-weibo-line text-xl"></i>
                      </div>
                      <div>
                        <h3 className="text-base font-heading font-bold text-foreground-950 mb-1">官方微博</h3>
                        <p className="text-sm text-foreground-600 mb-2">关注微博获取最新爆料动态</p>
                        <span className="text-sm text-primary-500 font-medium">微博搜索：吃瓜群官方</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* FAQ */}
        <section className="w-full py-12 md:py-20 bg-background-100">
          <div className="w-full px-4 md:px-6">
            <div className="mx-auto max-w-3xl">
              <div className="text-center mb-10 md:mb-14">
                <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950">
                  常见问题
                </h2>
              </div>
              <div className="space-y-3">
                {aboutFaqs.map((faq, index) => (
                  <details key={index} className="group bg-background-50 rounded-2xl p-5 md:p-6 cursor-pointer">
                    <summary className="flex items-center justify-between text-base font-heading font-bold text-foreground-950 list-none">
                      {faq.question}
                      <i className="ri-arrow-down-s-line text-lg transition-transform duration-300 group-open:rotate-180 text-foreground-500"></i>
                    </summary>
                    <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
                      {faq.answer}
                    </p>
                  </details>
                ))}
              </div>
            </div>
          </div>
        </section>

        <FAQPageSchema questions={aboutFaqs} />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}